var render, staticRenderFns
import script from "./CanvasAreaDraggable.vue?vue&type=script&lang=js&"
export * from "./CanvasAreaDraggable.vue?vue&type=script&lang=js&"
import style0 from "./CanvasAreaDraggable.vue?vue&type=style&index=0&id=94647aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94647aee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94647aee')) {
      api.createRecord('94647aee', component.options)
    } else {
      api.reload('94647aee', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/CanvasAreaDraggable.vue"
export default component.exports